/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import { MexcoreapipbCategoryTreeNode } from "generated/mexcoreapi-sellercenter.type"

/**
 * Mock data for category tree nodes
 * Based on Firefly staging data from food-data-service
 */
const rawMockCategoryTreeNodes: Omit<
  MexcoreapipbCategoryTreeNode,
  "hierarchyName" | "leafNode"
>[] = [
  // Level 1 Categories (Root)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUAGA6194",
    parentID: "",
    name: "LIFESTYLE",
    hierarchy: "CTN-C7MEMEDXJPUAGA6194",
    level: 1,
    sortOrder: 1,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUDVA3880",
    parentID: "",
    name: "ELECTRONICS",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880",
    level: 1,
    sortOrder: 2,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUEGA4654",
    parentID: "",
    name: "HEALTH",
    hierarchy: "CTN-C7MEMEDXJPUEGA4654",
    level: 1,
    sortOrder: 3,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUELA2811",
    parentID: "",
    name: "GROCERIES",
    hierarchy: "CTN-C7MEMEDXJPUELA2811",
    level: 1,
    sortOrder: 4,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUETA4142",
    parentID: "",
    name: "TOBACCO",
    hierarchy: "CTN-C7MEMEDXJPUETA4142",
    level: 1,
    sortOrder: 5,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUFCA9841",
    parentID: "",
    name: "FLOWERS & GIFTS",
    hierarchy: "CTN-C7MEMEDXJPUFCA9841",
    level: 1,
    sortOrder: 6,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUFGA8743",
    parentID: "",
    name: "BEAUTY",
    hierarchy: "CTN-C7MEMEDXJPUFGA8743",
    level: 1,
    sortOrder: 7,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUFNA8329",
    parentID: "",
    name: "MOTOR",
    hierarchy: "CTN-C7MEMEDXJPUFNA8329",
    level: 1,
    sortOrder: 8,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUFTA0139",
    parentID: "",
    name: "HOME & LIVING",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139",
    level: 1,
    sortOrder: 9,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUGGA9161",
    parentID: "",
    name: "MOM AND BABY",
    hierarchy: "CTN-C7MEMEDXJPUGGA9161",
    level: 1,
    sortOrder: 10,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUGLA6119",
    parentID: "",
    name: "FASHION",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119",
    level: 1,
    sortOrder: 11,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:31Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUGTA6311",
    parentID: "",
    name: "PETS",
    hierarchy: "CTN-C7MEMEDXJPUGTA6311",
    level: 1,
    sortOrder: 12,
    status: "ACTIVE",
    businessType: 1,
    metadata: "",
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - GROCERIES children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUHLA7489",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Ready To Eat",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUHLA7489",
    level: 2,
    sortOrder: 15,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-12"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:36Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUKJA8671",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Frozen",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUKJA8671",
    level: 2,
    sortOrder: 22,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-9"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUKNA2617",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Alcoholic Beverages",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUKNA2617",
    level: 2,
    sortOrder: 23,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUTLA8280",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Fruit & Vegetables",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUTLA8280",
    level: 2,
    sortOrder: 27,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-10"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUUAA6963",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Snacks & Confectionery",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUUAA6963",
    level: 2,
    sortOrder: 29,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-13"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUVRA1100",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Meat & Seafood",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUVRA1100",
    level: 2,
    sortOrder: 34,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-11"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUWJA2787",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Food Staples",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPUWJA2787",
    level: 2,
    sortOrder: 36,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-8"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU1GA4979",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Breakfast Cereals & Spreads",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU1GA4979",
    level: 2,
    sortOrder: 39,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-5"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU2EA2757",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Beverages",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU2EA2757",
    level: 2,
    sortOrder: 43,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVACA1355",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Bakery",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPVACA1355",
    level: 2,
    sortOrder: 50,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:38Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVCCA1001",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Dairy & Eggs",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPVCCA1001",
    level: 2,
    sortOrder: 53,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:39Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVAGA2665",
    parentID: "CTN-C7MEMEDXJPUELA2811",
    name: "Desserts",
    hierarchy: "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPVAGA2665",
    level: 2,
    sortOrder: 58,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-7"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:39Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - ELECTRONICS children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUKTA9841",
    parentID: "CTN-C7MEMEDXJPUDVA3880",
    name: "Gaming & Consoles",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPUKTA9841",
    level: 2,
    sortOrder: 24,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-5"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUVCA7044",
    parentID: "CTN-C7MEMEDXJPUDVA3880",
    name: "Cameras & Accessories",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPUVCA7044",
    level: 2,
    sortOrder: 32,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU2RA7353",
    parentID: "CTN-C7MEMEDXJPUDVA3880",
    name: "Audio",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPU2RA7353",
    level: 2,
    sortOrder: 45,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU3JA4328",
    parentID: "CTN-C7MEMEDXJPUDVA3880",
    name: "Computers & Accessories",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPU3JA4328",
    level: 2,
    sortOrder: 52,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:39Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU3VA1239",
    parentID: "CTN-C7MEMEDXJPUDVA3880",
    name: "Computer Components",
    hierarchy: "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPU3VA1239",
    level: 2,
    sortOrder: 60,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:40Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - HEALTH children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUJCA7035",
    parentID: "CTN-C7MEMEDXJPUEGA4654",
    name: "Health & Medicine",
    hierarchy: "CTN-C7MEMEDXJPUEGA4654/CTN-C7MEMEDXJPUJCA7035",
    level: 2,
    sortOrder: 17,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "he-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - FASHION children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUHAA0161",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Shoe Accessories",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUHAA0161",
    level: 2,
    sortOrder: 13,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-9"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:36Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUJRA6582",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Clothing Accessories",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUJRA6582",
    level: 2,
    sortOrder: 19,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUVJA8754",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Clothing",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754",
    level: 2,
    sortOrder: 33,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUWAA2087",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Shoes",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUWAA2087",
    level: 2,
    sortOrder: 35,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-10"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU1AA6213",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Costumes & Accessories",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPU1AA6213",
    level: 2,
    sortOrder: 38,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU2VA6215",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Eyewear",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPU2VA6215",
    level: 2,
    sortOrder: 46,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVBAA8646",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Bags",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPVBAA8646",
    level: 2,
    sortOrder: 62,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:40Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVBLA8689",
    parentID: "CTN-C7MEMEDXJPUGLA6119",
    name: "Jewelry",
    hierarchy: "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPVBLA8689",
    level: 2,
    sortOrder: 64,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-7"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:40Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - BEAUTY children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUWNA8952",
    parentID: "CTN-C7MEMEDXJPUFGA8743",
    name: "Beauty & Personal Care",
    hierarchy: "CTN-C7MEMEDXJPUFGA8743/CTN-C7MEMEDXJPUWNA8952",
    level: 2,
    sortOrder: 37,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "be-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - HOME & LIVING children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUHEA6959",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Household Supplies",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPUHEA6959",
    level: 2,
    sortOrder: 14,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUHVA5683",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Stationery",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPUHVA5683",
    level: 2,
    sortOrder: 16,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-5"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUJJA2077",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Furniture & Organization",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPUJJA2077",
    level: 2,
    sortOrder: 18,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUKCA3733",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Outdoor & Garden",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPUKCA3733",
    level: 2,
    sortOrder: 21,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:36Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU2LA9697",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Tools & Home Improvement",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPU2LA9697",
    level: 2,
    sortOrder: 44,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVDCA1204",
    parentID: "CTN-C7MEMEDXJPUFTA0139",
    name: "Worship Supplies",
    hierarchy: "CTN-C7MEMEDXJPUFTA0139/CTN-C7MEMEDXJPVDCA1204",
    level: 2,
    sortOrder: 78,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "hl-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:41Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - FLOWERS & GIFTS children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUTGA5707",
    parentID: "CTN-C7MEMEDXJPUFCA9841",
    name: "Fresh Flowers",
    hierarchy: "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707",
    level: 2,
    sortOrder: 26,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:34Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUURA2209",
    parentID: "CTN-C7MEMEDXJPUFCA9841",
    name: "Gifts",
    hierarchy: "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUURA2209",
    level: 2,
    sortOrder: 31,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU1RA9303",
    parentID: "CTN-C7MEMEDXJPUFCA9841",
    name: "Preserved & Dried Flower",
    hierarchy: "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPU1RA9303",
    level: 2,
    sortOrder: 41,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:36Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - TOBACCO children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUJVA8880",
    parentID: "CTN-C7MEMEDXJPUETA4142",
    name: "Tobacco Product",
    hierarchy: "CTN-C7MEMEDXJPUETA4142/CTN-C7MEMEDXJPUJVA8880",
    level: 2,
    sortOrder: 20,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "to-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU1VA0321",
    parentID: "CTN-C7MEMEDXJPUETA4142",
    name: "Vaporizers & Electronic Cigarettes",
    hierarchy: "CTN-C7MEMEDXJPUETA4142/CTN-C7MEMEDXJPU1VA0321",
    level: 2,
    sortOrder: 42,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "to-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:38Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - MOTOR children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUTCA0536",
    parentID: "CTN-C7MEMEDXJPUFNA8329",
    name: "Automotive",
    hierarchy: "CTN-C7MEMEDXJPUFNA8329/CTN-C7MEMEDXJPUTCA0536",
    level: 2,
    sortOrder: 25,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "mo-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:32Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUUJA1563",
    parentID: "CTN-C7MEMEDXJPUFNA8329",
    name: "Motorcycle",
    hierarchy: "CTN-C7MEMEDXJPUFNA8329/CTN-C7MEMEDXJPUUJA1563",
    level: 2,
    sortOrder: 30,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "mo-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:36Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 2 Categories - LIFESTYLE children
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUTRA6401",
    parentID: "CTN-C7MEMEDXJPUAGA6194",
    name: "Hobbies & Collections",
    hierarchy: "CTN-C7MEMEDXJPUAGA6194/CTN-C7MEMEDXJPUTRA6401",
    level: 2,
    sortOrder: 28,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "ls-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU1LA7139",
    parentID: "CTN-C7MEMEDXJPUAGA6194",
    name: "Sports & Outdoors",
    hierarchy: "CTN-C7MEMEDXJPUAGA6194/CTN-C7MEMEDXJPU1LA7139",
    level: 2,
    sortOrder: 40,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "ls-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:37Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPU3EA2588",
    parentID: "CTN-C7MEMEDXJPUAGA6194",
    name: "Books & Magazines",
    hierarchy: "CTN-C7MEMEDXJPUAGA6194/CTN-C7MEMEDXJPU3EA2588",
    level: 2,
    sortOrder: 47,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "ls-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Beverages (GROCERIES)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVXEA2297",
    parentID: "CTN-C7MEMEDXJPU2EA2757",
    name: "Carbonated Drinks",
    hierarchy:
      "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU2EA2757/CTN-C7MEMEDXJPVXEA2297",
    level: 3,
    sortOrder: 106,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-4-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:47Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUMCA2993",
    parentID: "CTN-C7MEMEDXJPU2EA2757",
    name: "Cordials & Squashes",
    hierarchy:
      "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU2EA2757/CTN-C7MEMEDXJPUMCA2993",
    level: 3,
    sortOrder: 121,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-4-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:48Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPUMGA0575",
    parentID: "CTN-C7MEMEDXJPU2EA2757",
    name: "Energy & Sports Drinks",
    hierarchy:
      "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU2EA2757/CTN-C7MEMEDXJPUMGA0575",
    level: 3,
    sortOrder: 122,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-4-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:48Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVURA4740",
    parentID: "CTN-C7MEMEDXJPU2EA2757",
    name: "Cultured Drinks",
    hierarchy:
      "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPU2EA2757/CTN-C7MEMEDXJPVURA4740",
    level: 3,
    sortOrder: 96,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-4-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:51Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Clothing (FASHION)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVWTA6636",
    parentID: "CTN-C7MEMEDXJPUVJA8754",
    name: "Activewear",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJPVWTA6636",
    level: 3,
    sortOrder: 104,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:38Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVXLA3901",
    parentID: "CTN-C7MEMEDXJPUVJA8754",
    name: "One-Pieces",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJPVXLA3901",
    level: 3,
    sortOrder: 107,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-10"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:13Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVKCA7973",
    parentID: "CTN-C7MEMEDXJPUVJA8754",
    name: "Beachwear",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJPVKCA7973",
    level: 3,
    sortOrder: 153,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:09Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPW1JA8169",
    parentID: "CTN-C7MEMEDXJPUVJA8754",
    name: "Bottoms",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJPW1JA8169",
    level: 3,
    sortOrder: 186,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-5"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:35Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJP2CVA7804",
    parentID: "CTN-C7MEMEDXJPUVJA8754",
    name: "Camisoles",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJP2CVA7804",
    level: 3,
    sortOrder: 247,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-4-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:48:14Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Gaming & Consoles (ELECTRONICS)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPXVNA2691",
    parentID: "CTN-C7MEMEDXJPUKTA9841",
    name: "Video Games",
    hierarchy:
      "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPUKTA9841/CTN-C7MEMEDXJPXVNA2691",
    level: 3,
    sortOrder: 253,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-5-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:27Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Beauty & Personal Care (BEAUTY)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVXRA5790",
    parentID: "CTN-C7MEMEDXJPUWNA8952",
    name: "Hair Care",
    hierarchy:
      "CTN-C7MEMEDXJPUFGA8743/CTN-C7MEMEDXJPUWNA8952/CTN-C7MEMEDXJPVXRA5790",
    level: 3,
    sortOrder: 108,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "be-1-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:01Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPXECA3674",
    parentID: "CTN-C7MEMEDXJPUWNA8952",
    name: "Makeup",
    hierarchy:
      "CTN-C7MEMEDXJPUFGA8743/CTN-C7MEMEDXJPUWNA8952/CTN-C7MEMEDXJPXECA3674",
    level: 3,
    sortOrder: 234,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "be-1-8"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:16Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Fresh Flowers (FLOWERS & GIFTS)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVVAA3623",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Ranunculus",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPVVAA3623",
    level: 3,
    sortOrder: 97,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-35"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:18Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVVTA1863",
    parentID: "CTN-C7MEMEDXJPU1RA9303",
    name: "Velvet Flower",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPU1RA9303/CTN-C7MEMEDXJPVVTA1863",
    level: 3,
    sortOrder: 100,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-3-5"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:27Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVXAA3833",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Lotus",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPVXAA3833",
    level: 3,
    sortOrder: 105,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-28"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:07Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVYTA6913",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Honeysuckle Flowers",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPVYTA6913",
    level: 3,
    sortOrder: 112,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-21"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:03Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVZVA3050",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Kapok Flower",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPVZVA3050",
    level: 3,
    sortOrder: 114,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-24"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:04Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPWCAA6074",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Jasmine",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPWCAA6074",
    level: 3,
    sortOrder: 132,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-23"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:04Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPWBAA3391",
    parentID: "CTN-C7MEMEDXJPUTGA5707",
    name: "Daisies",
    hierarchy:
      "CTN-C7MEMEDXJPUFCA9841/CTN-C7MEMEDXJPUTGA5707/CTN-C7MEMEDXJPWBAA3391",
    level: 3,
    sortOrder: 129,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fg-1-12"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:51Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 3 Categories - Tobacco Product (TOBACCO)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPVWAA0365",
    parentID: "CTN-C7MEMEDXJPUJVA8880",
    name: "Rolling Papers",
    hierarchy:
      "CTN-C7MEMEDXJPUETA4142/CTN-C7MEMEDXJPUJVA8880/CTN-C7MEMEDXJPVWAA0365",
    level: 3,
    sortOrder: 101,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "to-1-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:19Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPV1TA4948",
    parentID: "CTN-C7MEMEDXJPUJVA8880",
    name: "Cavendish Tobacco",
    hierarchy:
      "CTN-C7MEMEDXJPUETA4142/CTN-C7MEMEDXJPUJVA8880/CTN-C7MEMEDXJPV1TA4948",
    level: 3,
    sortOrder: 118,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "to-1-1"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:47Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPWEEA9700",
    parentID: "CTN-C7MEMEDXJPUJVA8880",
    name: "Cigars",
    hierarchy:
      "CTN-C7MEMEDXJPUETA4142/CTN-C7MEMEDXJPUJVA8880/CTN-C7MEMEDXJPWEEA9700",
    level: 3,
    sortOrder: 141,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "to-1-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:49Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 4 Categories - Hair Care (BEAUTY)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPX6JA5997",
    parentID: "CTN-C7MEMEDXJPVXRA5790",
    name: "Hair Styling Appliances",
    hierarchy:
      "CTN-C7MEMEDXJPUFGA8743/CTN-C7MEMEDXJPUWNA8952/CTN-C7MEMEDXJPVXRA5790/CTN-C7MEMEDXJPX6JA5997",
    level: 4,
    sortOrder: 195,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "be-1-6-4"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:27Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },

  // Level 4 Categories - Video Games (ELECTRONICS)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJP5JLA7708",
    parentID: "CTN-C7MEMEDXJPXVNA2691",
    name: "Playstation Games",
    hierarchy:
      "CTN-C7MEMEDXJPUDVA3880/CTN-C7MEMEDXJPUKTA9841/CTN-C7MEMEDXJPXVNA2691/CTN-C7MEMEDXJP5JLA7708",
    level: 4,
    sortOrder: 558,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "el-5-3-6"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:50:33Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [
      {
        attributeCluster: {
          attributeClusterID: "ACL-C63ASALTLADYAN5489",
          name: "Origin of Goods",
          nameLocalization: [
            {
              languageCode: "vi",
              value: "Origin of Goods attr ",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJANX3111",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJFVX6015",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJDME3438",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJEL21711",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: true,
              isShownToPax: false,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJBLX7531",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCE2GX6268",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJGTE8971",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 17,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C63ASALTLCJHUA9899",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 17,
          createdAt: "2024-11-20T04:49:10Z",
          updatedAt: "2026-01-23T05:25:14Z",
        },
        status: "DEACTIVATED",
        isGlobal: true,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LF52TKNUE68241",
          name: "Video game format",
          nameLocalization: [
            {
              languageCode: "id",
              value: "Format permainan video",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Định dạng trò chơi điện tử",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "รูปแบบวิดีโอเกม",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "Video game format sg",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2BWE1860",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2DT26699",
              isVariantSelectorEnabled: true,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2ERX9588",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2FNX5314",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2GJX3194",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2HE60431",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2JCN7859",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 3,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF52TN2JV67440",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 3,
          createdAt: "2025-12-17T06:09:38Z",
          updatedAt: "2026-02-16T07:59:57Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LF5CA3E1E29842",
          name: "Video game platform",
          nameLocalization: [
            {
              languageCode: "vi",
              value: "Nền tảng trò chơi điện tử",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "แพลตฟอร์มวิดีโอเกม",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "Video game platform",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Platform gim video",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LKTN9364",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LUTX8012",
              isVariantSelectorEnabled: true,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LVN69335",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LWN26220",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LXJN3391",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LYJE8022",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6LZDE5020",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LF5CA6L1G25454",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:09:22Z",
          updatedAt: "2025-12-17T06:09:22Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMBARMCGJ9930",
          name: "ESRB rating",
          nameLocalization: [
            {
              languageCode: "id",
              value: "Peringkat ESRB",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Xếp hạng từ Ủy ban Đánh giá Phần mềm Giải trí",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "เรตติ้ง ESRB",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "ESRB rating",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUECUE0295",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEENE3065",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEFC26315",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEFNX8965",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEGCT4478",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEGNE7633",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEHAX2075",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBAUEHNN7695",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 2,
          createdAt: "2025-12-17T06:06:01Z",
          updatedAt: "2026-02-20T13:27:46Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMBGCLHR27415",
          name: "National/Regional rating",
          nameLocalization: [
            {
              languageCode: "th",
              value: "การจัดอันดับระดับชาติ/ภูมิภาค",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "National/Regional rating",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Peringkat nasional/regional",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Xếp hạng quốc gia/khu vực",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVJET9106",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVTA61365",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVTVN4150",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVUTE6433",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVVSA0434",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVWMA9854",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVXJA1464",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBGFVYEA0083",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:06:01Z",
          updatedAt: "2025-12-17T06:06:01Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMBMGKGA66278",
          name: "PEGI rating",
          nameLocalization: [
            {
              languageCode: "vi",
              value:
                "Xếp hạng từ hệ thống phân loại trò chơi điện tử của châu Âu",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "เรตติ้ง PEGI",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "PEGI rating",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Peringkat PEGI",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUET25313",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUGR62458",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUHL61666",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUJBA7326",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUJVA1394",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUKG63439",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUKTJ0092",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 2,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBNBUTE66934",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 2,
          createdAt: "2025-12-17T06:06:01Z",
          updatedAt: "2026-02-20T13:27:28Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMBVTBBJJ5277",
          name: "Region code",
          nameLocalization: [
            {
              languageCode: "vi",
              value: "Mã vùng",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "รหัสภูมิภาค",
              aiTranslated: false,
            },
            {
              languageCode: "en",
              value: "Region code",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Kode wilayah",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU3ZCT4805",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU32CE7235",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU33EE4512",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU33WA6178",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU4AR21365",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU4BSA9682",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU4CL62963",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMBVU4DGT9785",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:06:01Z",
          updatedAt: "2025-12-17T06:06:01Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMCETVVVA8467",
          name: "Video game genre",
          nameLocalization: [
            {
              languageCode: "en",
              value: "Video game genre",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Genre gim video",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Thể loại trò chơi điện tử",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "ประเภทวิดีโอเกม",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6BE24208",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6DGE7937",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6DT69914",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6EG69940",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6ET68408",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6FV21116",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6GNA1361",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCEU6HAT2917",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:06:02Z",
          updatedAt: "2025-12-17T06:06:02Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFMCLLJZTE9929",
          name: "Video game sub-genre",
          nameLocalization: [
            {
              languageCode: "en",
              value: "Video game sub-genre",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Subgenre gim video",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Thể loại phụ của trò chơi điện tử",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "ประเภทย่อยของวิดีโอเกม",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDUE60055",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDWC20706",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDWT67624",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDXKA5753",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDXVJ4410",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDYG20544",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDYTE6290",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFMCLPDZEX3898",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:06:02Z",
          updatedAt: "2025-12-17T06:06:02Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C7V3LFXWGANATE8816",
          name: "Video game content features",
          nameLocalization: [
            {
              languageCode: "en",
              value: "Video game content features",
              aiTranslated: false,
            },
            {
              languageCode: "id",
              value: "Fitur konten gim video",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "Tính năng nội dung trò chơi điện tử",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "คุณลักษณะของเนื้อหาวิดีโอเกม",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEBLT8523",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEDLN5871",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEEET7648",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEEV62726",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEFJN2092",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEFVT6691",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEGPA0219",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: false,
              isMexSelfServe: false,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 0,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C7V3LFXWGCEHEE9249",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 0,
          createdAt: "2025-12-17T06:08:13Z",
          updatedAt: "2025-12-17T06:08:13Z",
        },
        status: "ACTIVE",
        isGlobal: false,
      },
      {
        attributeCluster: {
          attributeClusterID: "ACL-C36DEYVHR3LKSE2485",
          name: "Brand",
          nameLocalization: [
            {
              languageCode: "id",
              value: "brand ID name",
              aiTranslated: false,
            },
            {
              languageCode: "vi",
              value: "vietnamese name",
              aiTranslated: false,
            },
            {
              languageCode: "th",
              value: "thai name",
              aiTranslated: false,
            },
          ],
          businessType: "SHOP",
          status: "Enabled",
          icon: "https://photo-url",
          attributeClusterType: "PreDefined",
          attributeClusterOptions: [
            {
              countryID: 1,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVEVEJ1225",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 2,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVEYT65018",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 3,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVEXTN7527",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 4,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: true,
              isFilterOptionEnabled: true,
              version: 29,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DEYVHR74YCN6922",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 5,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVEWPA9721",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 6,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVEKLE1485",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 9,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVE1CX1348",
              isVariantSelectorEnabled: false,
            },
            {
              countryID: 10,
              isMandatory: false,
              isShownToPax: true,
              isMexSelfServe: true,
              isSearchKeywordEnabled: false,
              isFilterOptionEnabled: false,
              version: 28,
              createdAt: "0001-01-01T00:00:00Z",
              updatedAt: "0001-01-01T00:00:00Z",
              attributeClusterOptionID: "ACO-C36DE34JEVE2FA2507",
              isVariantSelectorEnabled: false,
            },
          ],
          metadata: {
            attributesLimitPerItem: 1,
            booleanMetadata: { defaultValue: false },
            integerMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            decimalMetadata: {
              min: { value: 0 },
              max: { value: 0 },
              numberOfDecimalPlaces: { value: 0 },
              units: "",
              unitLocalizations: [],
            },
            freeTextMetadata: { maxLength: 0 },
          },
          version: 29,
          createdAt: "2023-03-09T01:34:07Z",
          updatedAt: "2026-01-07T05:47:30Z",
        },
        status: "DEACTIVATED",
        isGlobal: true,
      },
    ],
  },

  // Level 4 Categories - One-Pieces (FASHION)
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJP4BNA7869",
    parentID: "CTN-C7MEMEDXJPVXLA3901",
    name: "Playsuits",
    hierarchy:
      "CTN-C7MEMEDXJPUGLA6119/CTN-C7MEMEDXJPUVJA8754/CTN-C7MEMEDXJPVXLA3901/CTN-C7MEMEDXJP4BNA7869",
    level: 4,
    sortOrder: 316,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "fa-1-10-3"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:47:47Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
  {
    categoryTreeNodeID: "CTN-C7MEMEDXJPWFCA7810",
    parentID: "CTN-C7MEMEDXJPVAGA2665",
    name: "Cheese and Spreads",
    hierarchy:
      "CTN-C7MEMEDXJPUELA2811/CTN-C7MEMEDXJPVAGA2665/CTN-C7MEMEDXJPWFCA7810",
    level: 3,
    sortOrder: 145,
    status: "ACTIVE",
    businessType: 1,
    metadata: '{"mkg_entity_id": "gr-7-2"}',
    createdAt: "0001-01-01T00:00:00Z",
    updatedAt: "2025-09-11T07:46:47Z",
    translation: {},
    icon: "",
    countryID: 1,
    attributeClusters: [],
  },
]

const idToName = new Map(
  rawMockCategoryTreeNodes.map(n => [n.categoryTreeNodeID, n.name]),
)
const parentIds = new Set(
  rawMockCategoryTreeNodes.map(n => n.parentID).filter(Boolean),
)

export const mockCategoryTreeNodes: MexcoreapipbCategoryTreeNode[] = rawMockCategoryTreeNodes.map(
  node => ({
    ...node,
    hierarchyName: node.hierarchy
      .split("/")
      .map(id => idToName.get(id) ?? id)
      .join(" > "),
    leafNode: !parentIds.has(node.categoryTreeNodeID),
  }),
)

/**
 * Helper function to filter category tree nodes based on query params
 */
export const filterCategoryTreeNodes = ({
  level,
  parentID,
  name,
  categoryTreeNodeIDs,
}: {
  level?: number
  parentID?: string
  name?: string
  categoryTreeNodeIDs?: string[]
}): MexcoreapipbCategoryTreeNode[] => {
  let filtered = [...mockCategoryTreeNodes]

  if (typeof level === "number") {
    filtered = filtered.filter(node => node.level === level)
  }

  if (parentID !== undefined) {
    filtered = filtered.filter(node => node.parentID === parentID)
  }

  if (categoryTreeNodeIDs !== undefined && categoryTreeNodeIDs.length > 0) {
    filtered = filtered.filter(node =>
      categoryTreeNodeIDs.includes(node.categoryTreeNodeID),
    )
  }

  if (name) {
    filtered = filtered.filter(node =>
      node.name.toLowerCase().includes(name.toLowerCase()),
    )
  }

  return filtered
}
